import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';	
import './fonts/AtlasGrotesk-Regular-App.ttf';
import './fonts/HarrisonSerifPro-Regular.ttf';
import AccountSetup from './AccountSetup';
import * as serviceWorker from './serviceWorker';
import pym from 'pym.js';

pym.Child({ polling: 100 });

const Root = () => ( <> <AccountSetup /> </>)
  
ReactDOM.render(<Root name="root" className="container"/>, document.getElementById('root'))


//ReactDOM.render(<App />, document.getElementById('root'));
//ReactDOM.render(<AccountSetup />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// MARKE_SB: TODO: I changes this and the "This action is insecure"-Error in FF vanished!
// But what are the possible side-effects??
serviceWorker.unregister();
